class URLUtil {
    static getDomainName(hostname) {
        if (this.regex.test(hostname)) {
            return hostname.match(this.regex)[1];
        }
        return null;
    }
    static resolveBackendEnv() {
        const hostName = window.location.hostname || '';
        if (hostName.includes('test')) {
            return 'test';
        }
        if (hostName.includes('dev2')) {
            return 'dev2';
        }
        if (['arendus', 'dev', 'localhost', 'ng-pood'].some((env) => hostName.includes(env))) {
            return 'dev';
        }
        return 'live';
    }
    static resolveBackendUrl(env) {
        const hostname = URLUtil.resolveBackendHost();
        const resolvedEnv = env || this.resolveBackendEnv();
        let tier = '';
        switch (resolvedEnv) {
            case 'dev':
                tier = '-arendus';
                break;
            case 'dev2':
                tier = '-dev2';
                break;
            case 'test':
                tier = '-test';
        }
        return `https://sso${tier}.${hostname}`;
    }
    static resolveBackendHost() {
        const hostName = window.location.hostname || '';
        if (URLUtil.ssoUIRegex.test(hostName)) {
            const parts = hostName.match(URLUtil.ssoUIRegex);
            return ((parts === null || parts === void 0 ? void 0 : parts.length) && parts[1]) || 'telia.ee';
        }
        return 'telia.ee';
    }
}
URLUtil.domains = [
    'telia\\.ee',
    'diil\\.ee',
    'elion\\.ee',
    'emt\\.ee',
    'simpel\\.ee',
    'super\\.ee',
    'teliatv\\.ee',
    'telia\\.com',
    'hgrupp\\.ee',
    'teliasonera\\.com'
];
URLUtil.ssoUiDomains = [
    'telia\\.ee',
    'diil\\.ee',
    'super\\.ee',
    'teliatv\\.ee',
    'coltat\\.teliasonera\\.com',
    'dst\\.telia\\.com'
];
URLUtil.regex = new RegExp(`^(?:(?:[A-Za-z0-9\-])+\.)*(${URLUtil.domains.join('|')})$`);
URLUtil.ssoUIRegex = new RegExp(`^(?:(?:[A-Za-z0-9\-])+\.)*(${URLUtil.ssoUiDomains.join('|')})$`);
URLUtil.getDomainNameFromUrl = (url) => {
    const hostname = URLUtil.getHostname(url);
    return URLUtil.getDomainName(hostname);
};
URLUtil.getHostname = (url) => {
    if (!url) {
        return '';
    }
    return URLUtil.extractHyperlink(url).hostname;
};
URLUtil.extractHyperlink = (url) => {
    const link = document.createElement('a');
    link.href = url;
    return link;
};

const OPENAM_COOKIE_NAME = 'iPlanetDirectoryPro';
const GA_COOKIE_NAME = 'gaString';
const SSO_COOKIE_AGE_IN_DAYS = 10 * 365; //Ten years
const TEN_SECONDS_IN_MILLIS = 10 * 1000;
const ONE_DAY_IN_MILLIS = 864e5;
const cookieNames = { dev: 'ssoui-arendus', test: 'ssoui-test', live: 'ssoui' };
const ignoredActions = ['showDealerSessionExpirationNotice'];
// keep in sync with interface declaration
function normalizeOptions(options) {
    const { authLevel, selectMandate, app, locale, panelFilter, hideB2B, autoSelectSelf, tabId, allowStatisticsCookies, forceSelectCustomerId, goto, customerId, hideRememberMe } = options;
    return {
        authLevel,
        selectMandate,
        app,
        locale,
        panelFilter,
        hideB2B,
        autoSelectSelf,
        tabId,
        allowStatisticsCookies,
        forceSelectCustomerId,
        goto,
        customerId,
        hideRememberMe
    };
}
// keep in sync with interface declaration
function normalizeConf(conf) {
    const { onLogin, onLogout, onSaveDealerPreferences, renderIframe, registerCookies, disableTabSync, env } = conf;
    return {
        onLogin,
        onLogout,
        onSaveDealerPreferences,
        renderIframe,
        registerCookies,
        disableTabSync,
        env
    };
}
/**
 * sso client script to be used in client side
 */
class SsoClient {
    static connect(conf, options) {
        return new SsoClient(conf, options);
    }
    constructor(conf, options) {
        this.options = {};
        this.handlers = [];
        this.handleStatisticsCookieDecline = () => {
            if (statisticsCookieConsent() !== 'true') {
                this.deleteGaCookieIfExists();
            }
        };
        this.deleteGaCookieIfExists = () => {
            if (getCookie(GA_COOKIE_NAME)) {
                deleteCookie(GA_COOKIE_NAME);
            }
        };
        this.startTimerForDealerAuthentication = () => {
            return setInterval(() => {
                const currentTime = new Date().getTime();
                if ((this.dealerSessionExpirationTime - 1000 * 15 * 60) - currentTime <= 0 && this.dealerSessionExpirationTime > currentTime) {
                    window.postMessage({ action: 'showDealerSessionExpirationNotice' }, '*');
                }
            }, TEN_SECONDS_IN_MILLIS * 6 * 2);
        };
        this.startLogoutTimerForDealer = () => {
            return setInterval(() => {
                if (this.dealerSessionExpirationTime <= new Date().getTime()) {
                    this.doLogout();
                }
            }, TEN_SECONDS_IN_MILLIS);
        };
        this.conf = normalizeConf(conf);
        this.setOptions(options);
        this.backendUri = URLUtil.resolveBackendUrl(this.conf.env);
        this.registerListeners();
        window.addEventListener('message', event => this.onMessageReceived(event));
        window.addEventListener('CookiebotOnLoad', () => this.handleStatisticsCookieDecline());
    }
    /** Renders a temporary iframe to load whatever context there currently is in sso session user context. */
    loadInitialState(tabId) {
        let src = this.getUrl('/ui/webapi', false, { tabId });
        this.renderTempAuthFrame(src);
    }
    /** Renders a temporary iframe to update the representative in sso session by the provided customer id. */
    updateRepresentativeByCustomerId(customerId, withoutBackendUri = false) {
        let src = this.getUrl('/ui/mandate/select', withoutBackendUri, { customerId: customerId });
        this.renderTempAuthFrame(src);
    }
    /** Sets options as composition of: defaults + (current options) + (specified options) */
    setOptions(options) {
        this.options = normalizeOptions({ locale: 'et', ...this.options, ...options });
    }
    /**
     * Set iframe path for logging in, passed options will override sso.options
     * onLoadedCallback function can be used for closing iframe, if needed.
     *
     * @param customOptions additional parameters to override stored options
     * @param onLoadedCallback optional method that will be invoked when the current frame receives 'loaded' push message. This callback will be invoked only
     *   once.
     * @returns {Promise<any>}
     */
    doLogin(customOptions, onLoadedCallback) {
        if (onLoadedCallback) {
            this.subscribe('loaded', onLoadedCallback, true);
        }
        if (this.iframe) {
            this.iframe.src = this.getLoginUrl(customOptions);
            this.iframe.style.display = (this.iframe.style.display === 'none') ? 'block' : this.iframe.style.display;
        }
        else {
            throw new Error('Iframe element not assigned, must assign with sso.setIframe(document.getElementById(\'ssoIframe\')');
        }
    }
    doLoginWithPromise(customOptions) {
        return new Promise(((resolve) => {
            this.doLogin(customOptions, resolve);
        }));
    }
    doLogout() {
        this.renderTempAuthFrame(this.getLogoutUrl());
        // send logoutEvent to all windows
        window.postMessage({ action: 'logout', data: {} }, '*');
        this.clearDealerTimeouts();
        return null;
    }
    getLoginUrl(customOptions = {}, withoutBackendUri = false) {
        return this.getUrl('/', withoutBackendUri, customOptions);
    }
    getLogoutUrl(withoutBackendUri = false) {
        return this.getUrl('/ui/webapi/logout', withoutBackendUri);
    }
    getDealerMandatesUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/mandates', withoutBackendUri);
    }
    getEmployeeSettingsUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/config', withoutBackendUri);
    }
    getSessionExpiringNoticeUrl(withoutBackendUri = false) {
        return this.getUrl('/admin/session-expiration-notification', withoutBackendUri);
    }
    getUrl(path, withoutBackendUri, customOptions = {}) {
        const mergedOptions = { ...this.options, ...(customOptions || {}) };
        if (mergedOptions.goto) {
            mergedOptions.goto = encodeURIComponent(mergedOptions.goto);
        }
        return `${!withoutBackendUri && this.backendUri || ''}${path}?webapi=true&${optionsToParamsStr(normalizeOptions(mergedOptions))}`;
    }
    addListenerFrame() {
        if (!this.conf.disableTabSync && !document.getElementById('sso.listener.iframe')) {
            let iframe = document.createElement('iframe');
            iframe.id = 'sso.listener.iframe';
            iframe.src = this.getUrl('/ui/listener', false);
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }
    }
    registerListeners() {
        this.addListenerFrame();
        this.registerOnLoadedCommon();
        this.registerConfiguredOnLogout();
        this.registerSaveDealerPreferences();
        this.registerOnDealerSessionExtended();
    }
    registerOnLoadedCommon() {
        this.subscribe('loaded', state => {
            this.handleGaStringCookie(state);
            this.handleSessionCookies(state);
            this.handleDealerSessionDuration(state);
            setSessionInfo(state);
            if (this.conf.onLogin) {
                this.conf.onLogin(state);
            }
        });
    }
    registerOnDealerSessionExtended() {
        this.subscribe('dealerSessionExtended', (data) => {
            this.handleDealerSessionDuration(data);
        });
    }
    handleSessionCookies(state) {
        if (this.conf.registerCookies && shouldRegisterCookies()) {
            if (state.am) {
                setCookieIfNeeded(OPENAM_COOKIE_NAME, state.am, 1);
            }
            const env = this.conf.env ? this.conf.env : 'live';
            setCookieIfNeeded(cookieNames[env] || 'ssoui', getSsoCookieValue(state.token), SSO_COOKIE_AGE_IN_DAYS);
        }
    }
    handleGaStringCookie(state) {
        const hasConsentedStatisticsCookie = statisticsCookieConsent() === 'true';
        if (state && hasConsentedStatisticsCookie) {
            setCookieIfNeeded(GA_COOKIE_NAME, state.auth ? state.auth.gaString : null, SSO_COOKIE_AGE_IN_DAYS);
        }
    }
    registerConfiguredOnLogout() {
        this.subscribe('logout', () => {
            this.deleteGaCookieIfExists();
            setSessionInfo({});
            if (this.conf.registerCookies && shouldRegisterCookies() && getCookie(OPENAM_COOKIE_NAME)) {
                deleteCookie(OPENAM_COOKIE_NAME);
            }
            if (this.conf.onLogout) {
                this.conf.onLogout();
            }
        });
    }
    registerSaveDealerPreferences() {
        this.subscribe('save-dealer-preferences', data => {
            if (this.conf.onSaveDealerPreferences) {
                this.conf.onSaveDealerPreferences(data);
            }
        });
    }
    clearDealerTimeouts() {
        if (this.sessionExpirationNoticeTimeout || this.sessionExpirationTimeout) {
            clearInterval(this.sessionExpirationNoticeTimeout);
            clearInterval(this.sessionExpirationTimeout);
        }
    }
    handleDealerSessionDuration(state) {
        this.dealerSessionExpirationTime = state === null || state === void 0 ? void 0 : state.sessionExpirationTime;
        if (this.dealerSessionExpirationTime) {
            this.clearDealerTimeouts();
            this.sessionExpirationNoticeTimeout = this.startTimerForDealerAuthentication();
            this.sessionExpirationTimeout = this.startLogoutTimerForDealer();
        }
    }
    /** Renders a temporary iframe containing sso webapi page, and removes it after it has loaded (and posted its message). */
    renderTempAuthFrame(src) {
        let iframe = document.createElement('iframe');
        iframe.id = 'sso.iframe';
        iframe.src = src;
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe.onload = () => {
            setTimeout(() => {
                iframe.remove();
            }, 0);
        };
    }
    setIframe(target) {
        if (!target) {
            throw new Error('Iframe not accessible, is dom loaded?');
        }
        this.iframe = target;
    }
    subscribe(action, callback, isPromise = false) {
        let handler = { action, callback, isPromise };
        this.handlers.unshift(handler); // insert to beginning
        return handler;
    }
    unsubscribe(handler) {
        const handlerIndex = this.handlers.indexOf(handler);
        if (handlerIndex === -1) {
            throw new Error(`Attempted to remove a handler but no matching handler was found.`);
        }
        this.handlers.splice(handlerIndex, 1);
    }
    onMessageReceived(event) {
        if (!URLUtil.getDomainNameFromUrl(event.origin)) {
            return;
        }
        if (typeof event.data !== 'object') {
            return; // invalid message
        }
        if (!event.data.action) {
            return;
        }
        const unsubscribeList = [];
        const handled = this.handlers.reduce((accumulatedHandled, handler) => {
            if (handler.action === event.data.action) {
                handler.callback(event.data.data);
                if (handler.isPromise) {
                    unsubscribeList.push(handler);
                }
                return true;
            }
            return accumulatedHandled;
        }, false);
        // cleanup promises
        unsubscribeList.forEach((item) => {
            this.unsubscribe(item);
        });
        if (!ignoredActions.includes(event.data.action) && !handled) {
            log(`Action ${event.data.action} has no subscribers`);
        }
    }
}
function optionsToParamsStr(options) {
    const toHttpParamName = (optionKey) => {
        return (optionKey === 'authLevel') ? 'authlevel' : optionKey;
    };
    options.allowStatisticsCookies = statisticsCookieConsent();
    const paramStrs = [];
    for (const optionKey of Object.keys(options)) {
        if (optionKey && options[optionKey]) {
            paramStrs.push(`${toHttpParamName(optionKey)}=${options[optionKey]}`);
        }
    }
    return paramStrs.join('&');
}
function log(...args) {
    console.log('[SSO]', ...args);
}
function setSessionInfo(data) {
    var _a, _b, _c, _d;
    // @ts-ignore
    if (!window.telia) {
        // @ts-ignore
        window.telia = {};
    }
    // @ts-ignore
    window.telia.session = {
        customer_id: (_b = (_a = data.auth) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.customerId,
        employee_id: (_d = (_c = data.auth) === null || _c === void 0 ? void 0 : _c.dealer) === null || _d === void 0 ? void 0 : _d.userName
    };
}
function statisticsCookieConsent() {
    var _a, _b, _c;
    // @ts-ignore
    if (!((_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.hasResponse)) {
        return '';
    }
    // @ts-ignore
    const isConsentGiven = (_c = (_b = window.Cookiebot) === null || _b === void 0 ? void 0 : _b.consent) === null || _c === void 0 ? void 0 : _c.statistics;
    return isConsentGiven === undefined ? '' : `${isConsentGiven}`;
}
function getSsoCookieValue(ssoSessionToken) {
    return ssoSessionToken ? ssoSessionToken.split('.')[0] : '';
}
function isTeliaDomain() {
    return getRootDomain() === 'telia.ee';
}
function shouldRegisterCookies() {
    return !isTeliaDomain() && URLUtil.resolveBackendHost() == 'telia.ee';
}
function getRootDomain() {
    return URLUtil.getDomainName(window.location.hostname);
}
function setCookieIfNeeded(name, value, days) {
    const currentValue = getCookie(name);
    if (!value && currentValue) {
        deleteCookie(name);
    }
    else if (value !== currentValue) {
        setCookie(name, value, days);
    }
}
function getCookie(name) {
    const cookies = '; ' + document.cookie;
    const parts = cookies.split(`; ${name}=`);
    if (parts.length == 2) {
        let part = parts.pop();
        return part ? part.split(';').shift() : null;
    }
    return null;
}
function setCookie(name, value, days = 7) {
    const domain = getRootDomain();
    if (domain) {
        const expires = new Date(Date.now() + days * ONE_DAY_IN_MILLIS).toUTCString();
        document.cookie = `${name}=${value}; expires=${expires}; path=/; domain=${domain}; SameSite=None; secure`;
    }
}
function deleteCookie(name) {
    if (getCookie(name)) {
        setCookie(name, '', -1);
    }
}
window['SsoClient'] = SsoClient;

export { SsoClient as default, deleteCookie, getCookie, getRootDomain, getSsoCookieValue, isTeliaDomain, setCookie, setCookieIfNeeded, shouldRegisterCookies };
